import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Office } from 'app/core/models/office.model';
import { keyedStatusOptions } from 'app/core/options/office-status.opts';
import { OfficeComponent } from '../../../shared/components/office/office.component';

import { BlankValueDashComponent } from '../../../shared/components/blank-value-dash/blank-value-dash.component';
import { PhoneNumberComponent } from '../../../shared/components/phone-number/phone-number.component';
import { OfficeFaxComponent } from '../../../shared/components/office-fax/office-fax.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { JoinListPipe } from '../../../shared/pipes/join-list.pipe';

@Component({
    selector: 'app-office-header',
    templateUrl: './office-header.component.html',
    styleUrls: ['./office-header.component.scss'],
    imports: [OfficeComponent,
              BlankValueDashComponent,
              PhoneNumberComponent,
              OfficeFaxComponent,
              FaIconComponent,
              JoinListPipe]
})
export class OfficeHeaderComponent {
  @Input() office: Office;
  @Output() editDetails = new EventEmitter();

  keyedStatusOptions = keyedStatusOptions;

  onEdit($event) {
    $event.preventDefault();
    this.editDetails.emit();
  }
}
